import { GlobalStoreStateConfiguration } from '../stores/globalStore';
import { useTribalContext } from '../context/tribal';
import { isStockCar } from '../modules/utils/storeUtils';
import { GetConfiguratorUrlByMarketingShortCodeDTO } from '@tribal-worldwide-london/fa-agent-service-vwg';

const useAgentService = () => {
  const { configManager, agentService } = useTribalContext();

  return {
    getConfiguratorUrl: (configuration: GlobalStoreStateConfiguration) => {
      if (isStockCar(configuration) || !configuration.marketingShortCode)
        return configManager.get('urls.configurator');

      const req = new GetConfiguratorUrlByMarketingShortCodeDTO(
        configuration.marketingShortCode
      );
      const url = agentService.getConfiguratorUrlByMarketingShortCode(req);
      return url;
    },
  };
};

export default useAgentService;
